import { MouseEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    colors,
    VisibilityIcon,
    VisibilityOffIcon
} from "@dotnet/telematics-design-system";

import ButtonDefault from "components/DesignComponents/ButtonDefault";
import InputField, {
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";
import { TooltipGeneral } from "components/DesignComponents/Tooltips/TooltipGeneral";
import { TOOLTIP_PLACEMENT } from "components/DesignComponents/Tooltips/types/enums";

import { PasswordInputFieldProps } from "./types";

const PasswordInputField = ({
    name,
    value,
    label,
    onChange
}: PasswordInputFieldProps) => {
    const { gray500, gray600 } = colors;

    const { t } = useTranslation();

    const [showPassword, setShowPassword] = useState(false);

    const togglePswVisibility = (e: MouseEvent<HTMLSpanElement>) => {
        e.preventDefault();
        setShowPassword(prev => !prev);
    };

    return (
        <InputField
            fullWidth
            required
            value={value}
            name={name}
            labelLeft={label}
            placeholder={t("Dialog##set bluetooth password##enter password")}
            size={INPUT_FIELD_SIZES.Medium}
            type={showPassword ? "text" : "password"}
            onChange={onChange}
            iconRight={
                <TooltipGeneral
                    disableTouchListener
                    placement={TOOLTIP_PLACEMENT.TopEnd}
                    title={
                        showPassword
                            ? t("Security##password##hide password")
                            : t("Security##password##show password")
                    }
                    css={css({
                        "& .MuiTooltip-tooltip": {
                            marginRight: "-6px"
                        }
                    })}
                >
                    <ButtonDefault
                        type="button"
                        css={css({
                            border: "none",
                            background: "none",
                            display: "flex",
                            cursor: "pointer",
                            color: gray500,
                            transition:
                                "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

                            "&:hover": {
                                color: gray600
                            }
                        })}
                        onMouseDown={e => togglePswVisibility(e)}
                    >
                        {showPassword ? (
                            <VisibilityOffIcon />
                        ) : (
                            <VisibilityIcon />
                        )}
                    </ButtonDefault>
                </TooltipGeneral>
            }
        />
    );
};

export default PasswordInputField;
